import "react-toggle/style.css";
import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import FieldText from "../Fields/FieldText";
import AlertComponent from "../AlertComponent";
import { Context } from "../../Reducers/Store";

function AddOrEditS3Output(props) {
  const { outputName, handleAddNewElementsOutput } = props;
  const [state, dispatch] = useContext(Context);

  const handleAddItem = () => {
    if (!outputName) {
      return AlertComponent("Error", "Output name is required", {
        icon: `error`,
      });
    }

    if (!s3FilesLocation) {
      return AlertComponent("Error", "S3 File Location is required", {
        icon: `error`,
      });
    }

    const item = {
      name: outputName,
      outputType: `S3`,
    };

    handleAddNewElementsOutput(item);
  };

  const s3FilesLocation = `s3://cs-${state.church.id}/channel/My-Channel-Name/[EVENT-NAME]`;

  return (
    <div>
      <FieldText
        label="Files Location"
        type="text"
        placeholder="s3:/cs-08dafb44-0a7d-4d15-8989-2244e20b53de/My-Channel-Name/[EVENT-NAME]/"
        value={s3FilesLocation}
        className="col-md-12"
        inputClassName={`inputOption`}
        disabled={true}
        readonly={true}
      />
      <Button className="dark-btn" onClick={handleAddItem}>Add</Button>
    </div>
  );
}

export default AddOrEditS3Output;
